module.exports = __webpack_public_path__ + "img/statement-active.dbb319bc.svg";